export const formattedDate = data => {
    if (!data) return;
    data = new Date(data.replace(/-/g, '/'));
    return (
        Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(data) + ' às ' + Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' }).format(data)
    );
};

export const dataInformadaMaiorQueHoje = data => {
    if (!data) return;
    let date = new Date(data.replace(/-/g, '/'));
    let today = new Date();

    return date >= today ? true : false;
};

export const ehCpfValido = cpf => {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) {
        return false;
    } else if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999' ||
        cpf === '00000000191'
    ) {
        return false;
    }

    let numero = [];
    for (let index = 1; index <= 11; index++) {
        numero[index] = parseInt(cpf.substring(index - 1, index));
    }

    let soma = 10 * numero[1] + 9 * numero[2] + 8 * numero[3] + 7 * numero[4] + 6 * numero[5] + 5 * numero[6] + 4 * numero[7] + 3 * numero[8] + 2 * numero[9];
    soma = soma - 11 * parseInt(soma / 11);

    let resultado1;
    if (soma === 0 || soma === 1) {
        resultado1 = 0;
    } else {
        resultado1 = 11 - soma;
    }

    if (resultado1 === numero[10]) {
        soma = numero[1] * 11 + numero[2] * 10 + numero[3] * 9 + numero[4] * 8 + numero[5] * 7 + numero[6] * 6 + numero[7] * 5 + numero[8] * 4 + numero[9] * 3 + numero[10] * 2;
        soma = soma - 11 * parseInt(soma / 11);

        let resultado2;
        if (soma === 0 || soma === 1) {
            resultado2 = 0;
        } else {
            resultado2 = 11 - soma;
        }

        if (resultado2 === numero[11]) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

export const ehEmailValido = email => {
    return /\S+@\S+\.\S+/.test(email);
};

export const decodeHexHtmlCharCodes = str => {
    return str.replace(/(&#x(\w{2});)/g, function (match, capture, charCode) {
        return String.fromCharCode('0x' + charCode);
    });
};
